import { updateSignUpState } from "../../../store/auth.tsx";
import { appendSignUpOptionsResponse } from "../../../store/conversation.tsx";
import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";

const handleInitiateSignUp = (enteredText: string, dispatch: any) => {
  if (
    enteredText.toLowerCase() ===
    i18n
      ._(
        msg({
          message: "create an account",
          context: "Message initiating the signup flow",
        }),
      )
      .toLowerCase()
  ) {
    dispatch(
      updateSignUpState({
        signUpToken: null,
        termsAndConditionsHash: null,
        dataProtectionPolicyHash: null,
        companyName: null,
        isComplete: false,
      }),
    );
    dispatch(
      appendSignUpOptionsResponse(
        i18n._(
          msg({
            message: `Let me help you create an account! 🚀😊\nFirst, choose your preferred single sign on platform:`,
            context:
              "Message informing the user on which providers are available for registration with the application.",
          }),
        ),
        true,
      ),
    );
  }
};

export default handleInitiateSignUp;
